import React from "react";
import { useState } from "react";
import { isPasswordStrong } from "../../../services/login.service";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import { css } from "@emotion/react";
import { useAuth } from "../../../hooks/useAuth";

import "./Style.css";
import { getFiduciaToken } from "../../../utils/sessionMethods";

const PrimeiroAcesso = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [newTransationalPassword, setNewTransationalPassword] = useState("");
  const [confirmnewTransationalPassword, setConfirmNewTransationalPassword] =
    useState("");

  const {
    firstAccessFiducia,
    isFirstAccessConfirmed,
    firstAccessLoader,
    setIsFirstAccess,
    setIsFirstAccessConfirmed,
  } = useAuth();

  const override = css`
    display: block;
    width: 30px !important;
    height: 30px !important;
    left: 10px !important;
    top: -5px !important;
    position: absolute;
  `;

  function handleSubmit() {
    if (!isPasswordStrong(newPassword)) {
      toast.error(
        "Senha muito fraca, a senha deve conter pelo menos 8 dígitos, incluindo números, símbolos, letras minúsculas e maiúsculas"
      );
      return "";
    }

    if (newPassword !== confirmNewPassword) {
      toast.error("As senhas de acesso são diferentes");
      return "";
    }

    if (newTransationalPassword !== confirmnewTransationalPassword) {
      toast.error("As senhas de transação são diferentes");
      return "";
    }

    firstAccessFiducia(getFiduciaToken(), newPassword, newTransationalPassword);
  }

  function handleBackToConfirm() {
    setIsFirstAccess(false);
    setIsFirstAccessConfirmed(false);
  }

  return (
    <>
      {!isFirstAccessConfirmed ? (
        <div className="area-login first-access">
          <h1>Este é o seu primeiro acesso</h1>
          <h2>Defina suas senhas</h2>

          <div className="new-password-area">
            <div className="col-xl-6">
              <label>Senha de Acesso *</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
              />
            </div>
            <div className="col-xl-6">
              <label>Confirme Senha de Acesso *</label>
              <input
                type="password"
                value={confirmNewPassword}
                onChange={(e) => {
                  setConfirmNewPassword(e.target.value);
                }}
              />
            </div>
          </div>
          <h6>
            *minimo 8 caracteres, contendo número, letra maiúscula e letra
            minúscula
          </h6>
          <div className="transational-password-area">
            <div className="col-xl-6">
              <label>Senha de Transações</label>
              <input
                type="password"
                value={newTransationalPassword}
                onChange={(e) => {
                  setNewTransationalPassword(e.target.value);
                }}
              />
            </div>
            <div className="col-xl-6">
              <label>Confirme Senha de Transações</label>
              <input
                type="password"
                value={confirmnewTransationalPassword}
                onChange={(e) => {
                  setConfirmNewTransationalPassword(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="button-area">
            <button onClick={handleSubmit}>Confirmar</button>
          </div>
        </div>
      ) : (
        <div className="area-login first-access-confirm">
          <h1>Senhas definidas com sucesso!</h1>
          <h2>Você já pode acessar sua conta!</h2>

          <div>
            <button onClick={handleBackToConfirm}>
              <ClipLoader
                loading={firstAccessLoader}
                color="var(--text-primary)"
                css={override}
              />
              Voltar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PrimeiroAcesso;
